export class LoginResponse {
    hospitalId: string;
    id: string;
    pid: string;
    role: any;
    subOperatorId: string;
    token: string;
}
